import React from 'react'
import { Link } from "gatsby"
import logoImg from "@images/roca-logo.jpg"
import { languageUtils } from "@utils/language"

const Logo = ({ url }) => {

    const lang = languageUtils.getLanguage()

    return (<>

        { url &&
            <Link className="header-logo" to={url}>
                <img className="header-logo-image"
                    src={logoImg}
                    alt="Roca logo" />
                <div className="header-logo-title">{lang === 'es' ? 'Memoria anual 2020' : 'Annual report 2020'}</div>
            </Link>
        }
    </>)
}

export default Logo;
